import { jsx as _jsx } from "nativewind/jsx-runtime";
import React, { createContext, useContext, useMemo, } from 'react';
import { useWindowDimensions } from 'react-native';
import { DESKTOP_BREAKPOINT } from '../constants/layout';
const ResponsiveContext = createContext(null);
export function ResponsiveProvider({ children }) {
    const { width: windowWidth, height: windowHeight } = useWindowDimensions();
    const value = useMemo(() => ({
        windowWidth,
        windowHeight,
        isDesktop: windowWidth >= DESKTOP_BREAKPOINT,
        isMobile: windowWidth < DESKTOP_BREAKPOINT,
    }), [windowWidth, windowHeight]);
    return (_jsx(ResponsiveContext.Provider, { value: value, children: children }));
}
/**
 * Responsive Context 사용 hook
 * @throws ResponsiveProvider 내부가 아닐 때 에러
 */
export function useResponsive() {
    const context = useContext(ResponsiveContext);
    if (!context) {
        throw new Error('useResponsive must be used within ResponsiveProvider');
    }
    return context;
}
